import React from 'react';
import classNames from 'classnames';

export function SectionTitle(props: React.ComponentProps<'h5'>) {
  return (
    <h5
      {...props}
      className={classNames(
        'text-sm font-medium text-black-900 dark:text-white-50',
        props.className
      )}
    />
  );
}
